import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TrackingActions, TrackingActitonTypes } from './tracking.actions';
import { Tracking } from '../../_models/tracking';
import { User } from '../../_models/user';

export interface State extends fromRoot.State {
	trackings: TrackingState;
}

export interface TrackingState {
    currentTrackingId: bigint | null;
    currentTracking: Tracking;
	trackingList: Tracking[];
	actionTrackingList: Tracking[];
	userList: User[];

	filterFields: any;

	error: string;
}

const initialItem: Tracking = {
  id: null,
  section: null,
  action_id: null,
  action_name: null,
  user_id: null,
  username: null,
  group_id: null,
  group_name: null,
  enviroment: null,
  company: null,
  permissions: null,
  lang: null,
  table: null,
  field: null,
  type_value: null,
  value: null,
  new_value: null,
  element_id: null,
  element_info: null,
  target_id: null,
  target_info: null,
  date: null
};

const initialState: TrackingState = {
    currentTrackingId: null,
    currentTracking: initialItem,
	trackingList: [],
	actionTrackingList: [],
	userList: [],
	filterFields: [],
	error: ''
};

const getTrackingFeatureState = createFeatureSelector<TrackingState>('trackings');

export const getCurrentTrackingId = createSelector(
	getTrackingFeatureState,
	state => state.currentTrackingId
);

export const getCurrentTracking = createSelector(
    getTrackingFeatureState,
    getCurrentTrackingId,
    (state, currentTrackingId) => {
        if (currentTrackingId == null) {
            return initialItem;
        } else {
            return currentTrackingId ? state.trackingList.find(p => p.id === currentTrackingId) : null;
        }
    }
);

export const getTrackingList = createSelector(
	getTrackingFeatureState,
	state => state.trackingList
);

export const getActionTrackingList = createSelector(
	getTrackingFeatureState,
	state => state.actionTrackingList
);

export const getUserList = createSelector(
	getTrackingFeatureState,
	state => state.userList
);

export const getFilterFields = createSelector(
	getTrackingFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getTrackingFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: TrackingActions): TrackingState {

	// console.log('--> Tracking Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Tracking type: ');
	// console.log(action.type);

	switch (action.type) {

		case TrackingActitonTypes.SetCurrentTracking:

			console.log('--> Entando en acción SetCurrentTracking.');

			if (action.payload !== null) {

				return {
					...state,
					currentTrackingId: action.payload.id,
					currentTracking: action.payload
				};
			} else {
				return {
					...state,
					currentTrackingId: null,
					currentTracking: initialItem
				};
			}

		case TrackingActitonTypes.SetCurrentTrackingId:

			console.log('--> Entando en acción SetCurrentTracking.');

			return {
                ...state,
				currentTrackingId: action.payload
			};

		case TrackingActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

        case TrackingActitonTypes.GetCurrentTracking:

			console.log('--> Entando en acción GetCurrentTracking.');

			return state;

		case TrackingActitonTypes.ClearTracking:

			console.log('--> Entando en acción ClearTracking.');

			return {
					...state,
					currentTrackingId: null,
					currentTracking: null,
					actionTrackingList: []
				};


		case TrackingActitonTypes.InicializeTracking:

			console.log('--> Entando en acción InicializeTracking.');

			state = initialState;

			return state;


		case TrackingActitonTypes.AddTracking:

			console.log('--> Entando en acción AddTracking. => Payload = ');
			console.log(action.payload);

			let auxActionTrackingList = [];

			if (action.payload !== undefined && action.payload !== null) {

				let exist = false;

				auxActionTrackingList = state.actionTrackingList.map( item => {

					// Si en el histórico existe una acción similar para el mismo elemento,
					// entonces lo que se hace es sustituirla por la nueva.
					if (action.payload.table === item.table &&
						action.payload.element_id === item.element_id &&
						action.payload.field === item.field &&
						action.payload.action_id === item.action_id) {
							exist = true;

							// NOTA: Se mantiene el valor antiguo inicial que existía para esa acción en el histórico
							// porque si aún sigue ahí es que todavía no se había pasado a la base de datos.
							action.payload.value = item.value;

							return action.payload;
					} else {
						return item;
					}

				});

				if (!exist) {
					// Si no hay ninguna acción similar en el histórico entonces
					// se añade el nuevo tracking al listado ya existente.
					auxActionTrackingList.push(action.payload);
				}
				return {
					...state,
					actionTrackingList: auxActionTrackingList
				};
			}

			return {
					...state,
					actionTrackingList: state.actionTrackingList
				};

		case TrackingActitonTypes.LoadTrackingsSuccess:

			console.log('--> Entando en acción LoadTrackingsSuccess. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					trackingList: action.payload,
					error: ''
				};

		case TrackingActitonTypes.LoadTrackingsFail:

			console.log('--> Entando en acción LoadTrackingsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					trackingList: [],
					error: action.payload
				};

		case TrackingActitonTypes.UpdateTrackingSuccess:

			console.log('--> Entando en acción UpdateTrackingSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxTrackingList = [];

			if (action.payload !== undefined) {
				console.log(' -> El tracking a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxTrackingList = state.trackingList.map(
					item => action.payload.id === item.id ? action.payload : item);

					return {
						...state,
						trackingList: auxTrackingList,
						currentTrackingId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El tracking a modificar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el tracking.'
				};
			}

		case TrackingActitonTypes.UpdateTrackingFail:

			console.log('--> Entrando en acción UpdateTrackingFail.');

			return {
					...state,
					error: action.payload
				};

		case TrackingActitonTypes.CreateTrackingSuccess:

			console.log('--> Entrando en acción CreateTrackingSuccess.');

			// Se actualiza en el listdo el elemento que se ha creado.
			// this.currentTrackings = null;

			if (action.payload !== undefined) {
				console.log(' -> El tracking creado es:');
				console.log(action.payload);

				if (action.payload != null) {

					state.trackingList.push(action.payload);

					return {
						...state,
						trackingList: state.trackingList,
						currentTrackingId: action.payload.id,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El tracking a crear está vacío.');

				return {
					...state,
					currentTrackingId: null,
					error: 'No se ha podido crear el tracking.'
				};
			}

		case TrackingActitonTypes.CreateTrackingFail:

			console.log('--> Entrando en acción CreateTrackingFail.');

			return {
					...state,
					currentTrackingId: null,
					error: action.payload
				};

		case TrackingActitonTypes.DeleteTrackingSuccess:

			console.log('--> Entrando en acción DeleteTrackingSuccess.');

			// Se actualiza en el listado el elemento que se ha creado.
			// this.currentTrackings = null;

			if (action.payload !== undefined) {
				console.log(' -> El tracking borrado con éxito es:');
				console.log(action.payload);

				if (action.payload != null) {

					const filterList = state.trackingList.filter((item) => item.id.toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de trackings:');
					console.log(filterList);

					return {
						...state,
						trackingList: filterList,
						currentTrackingId: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El tracking a crear está vacío.');

				return {
					...state,
					currentTrackingId: null,
					error: 'No se ha podido crear el tracking.'
				};
			}

		case TrackingActitonTypes.DeleteTrackingFail:

			console.log('--> Entrando en acción DeleteTrackingSuccess.');

			return {
					...state,
					currentTrackingId: null,
					error: action.payload
				};


		case TrackingActitonTypes.LoadUsersSuccess:

			console.log('--> Entando en acción LoadUsersSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					userList: action.payload,
					error: ''
				};

		case TrackingActitonTypes.LoadUsersFail:

			console.log('--> Entando en acción LoadUsersFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					userList: [],
					error: action.payload
				};

		default:
			return state;
	}
}
